var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
const _require = require('@truqc/content-path'),
  enumerateWildcardPath = _require.enumerateWildcardPath;
const _require2 = require('./filterObject'),
  filterObject = _require2.filterObject;
const array = [{
  identifier: 'station1',
  title: 'Station 1'
}, {
  identifier: 'station2',
  title: 'Station 2'
}, {
  identifier: 'station3',
  title: 'Station 3'
}, {
  identifier: 'station4',
  title: 'Station 4'
}, {
  identifier: 'station5',
  title: 'Station 5'
}, {
  identifier: 'station6',
  title: 'Station 6'
}, {
  identifier: 'cab',
  title: 'Cab'
}, {
  identifier: 'boom',
  title: 'Boom'
}, {
  identifier: 'axles',
  title: 'Axles'
}, {
  identifier: 'boomSupport',
  title: 'Boom Support'
}, {
  identifier: 'engine',
  title: 'Engine'
}, {
  identifier: 'fenders',
  title: 'Fenders'
}, {
  identifier: 'topHandler',
  title: 'Top Handler'
}, {
  identifier: 'smallSubs',
  title: 'Small Subs'
}, {
  identifier: 'paint',
  title: 'Paint'
}, {
  identifier: 'testAndAdjust',
  title: 'Test & Adjust'
}];
const getAssignmentGroups = () => array.reduce((acc, item, index) => {
  acc[item.identifier] = {
    title: item.title,
    _created: index + 1
  };
  return acc;
}, {});
const processAssignments = (checklists, processor) => {
  const questionPaths = '*/questionGroups/*/questions/*';
  const deficiencies = filterObject(checklists, questionPaths, 'option', 'fail');
  const photoPaths = '*/questionGroups/*/questions/*/supplementalData/photosCollection/*';
  enumerateWildcardPath(deficiencies, photoPaths, (photoPath, photoValue) => {
    if (photoValue !== undefined) {
      const _photoValue$status = photoValue.status,
        _photoValue$status2 = _photoValue$status === void 0 ? {} : _photoValue$status,
        open = _photoValue$status2.open,
        complete = _photoValue$status2.complete,
        _photoValue$assignedT = photoValue.assignedTo,
        assignedTo = _photoValue$assignedT === void 0 ? {} : _photoValue$assignedT;
      const _Object$keys = Object.keys(assignedTo),
        _Object$keys2 = _slicedToArray(_Object$keys, 1),
        identifier = _Object$keys2[0];
      const plusOpen = open !== undefined ? 1 : 0;
      const plusComplete = complete !== undefined ? 1 : 0;
      processor(identifier, plusOpen, plusComplete);
    }
  });
};
module.exports = {
  getAssignmentGroups,
  processAssignments
};